export const noBrand = {
  color: "yellow-c-nobrand",
  hex: "#FFE926",
};
